module.exports = __webpack_public_path__ + "img/Facade-More-521x316.b844a635.jpg";